"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Icons_1 = require("../Icons");
exports.treeViewCellTestIdPrefix = 'tree-view-cell';
exports.getTreeViewCellTestId = function (rowKey) { return exports.treeViewCellTestIdPrefix + "-" + rowKey; };
exports.ExpansionIndicatorTestId = 'treeview-expansion-button';
exports.ExpansionIndicatorOpenClass = 'open';
exports.ExpansionIndicatorClosedClass = 'closed';
exports.IndentationSpacerElementId = 'indentation-spacer';
var NestingIndentWidthPerLevel = 9;
var ExpansionIndicatorWidth = 12;
var ExpansionIndicatorMinHeight = 23;
var CellStyle = {
    display: 'flex',
    flexDirection: 'row'
};
var ExpansionIndicatorContainerStyle = {
    minWidth: ExpansionIndicatorWidth,
    paddingRight: widgets_1.TabStyles.Spacing.SmallSpace,
    display: 'flex',
};
var CellFormatterContainerStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
};
/** This function returns a normal data grid cell stateless component, but it must be used with
 *  data grids backed by a FractalRowStore, because it expects the row on the cell props to be of
 *  type FractalDataGridRow.
 */
function IndentedCellWithExpansionIndicatorComponent(CellFormatter, selectRowOnExpansion) {
    return function IndentedCellWithExpansionIndicator(props) {
        var row = props.row;
        var shouldShowExpansionIndicator = row.hasChildren;
        var emptySpaceWidth = NestingIndentWidthPerLevel * (row.nestingLevel || 0);
        // TODO: Use a React class here so the callback can be bound?
        return (React.createElement("div", { "data-tb-test-id": exports.getTreeViewCellTestId(props.row.key), style: CellStyle },
            React.createElement("div", { "data-tb-test-id": exports.IndentationSpacerElementId, style: { minWidth: emptySpaceWidth } }),
            React.createElement("div", { style: ExpansionIndicatorContainerStyle }, shouldShowExpansionIndicator && React.createElement(Chevron, { expansionHandler: row.expansionHandler, isExpanded: row.isExpanded, isSelected: props.isSelected, selectRowOnExpansion: selectRowOnExpansion })),
            React.createElement("div", { style: CellFormatterContainerStyle },
                React.createElement(CellFormatter, __assign({}, props)))));
    };
}
exports.IndentedCellWithExpansionIndicatorComponent = IndentedCellWithExpansionIndicatorComponent;
function Chevron(props) {
    var className = props.isExpanded ? exports.ExpansionIndicatorOpenClass : exports.ExpansionIndicatorClosedClass;
    var style = props.isExpanded ? Chevron.OpenStyle : Chevron.ClosedStyle;
    var clickHandler = function (e) {
        if (props.expansionHandler) {
            props.expansionHandler(!props.isExpanded);
            if (!props.selectRowOnExpansion || props.isSelected) {
                // If selectRowOnExpansion == false, stop propagating the click
                // to prevent the row from being selected. Otherwise,
                // expanding or collapsing WILL select an unselected project,
                // but expanding or collapsing will NOT deselect a selected project.
                e.stopPropagation();
            }
        }
    };
    return (React.createElement(widgets_1.PointerEventWrapper, { pointerClick: clickHandler },
        React.createElement("div", { "data-tb-test-id": exports.ExpansionIndicatorTestId, style: style, className: className })));
}
exports.Chevron = Chevron;
(function (Chevron) {
    Chevron.OpenStyle = {
        flex: 1,
        width: '100%',
        height: '100%',
        minHeight: ExpansionIndicatorMinHeight,
        backgroundImage: "url(" + Icons_1.Icons.ExpansionIndicator + ")",
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        cursor: 'pointer',
        verticalAlign: 'middle'
    };
    Chevron.ClosedStyle = __assign(__assign({}, Chevron.OpenStyle), { transform: 'rotate(270deg)' });
})(Chevron = exports.Chevron || (exports.Chevron = {}));
//# sourceMappingURL=IndentedCellWithExpansionIndicator.js.map